import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { cn } from '@avanta/shared/utils/cn';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AnimatedContainer } from 'components/ui/AnimatedContainer';
import { FLOW_MODES } from 'types/appointments';
import { AppointmentsReservePayload } from '../../../../types';

const ButtonCTA = ({ className }: { className?: string }): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  const { reset } = useFormContext();

  const handleClick = (): void => {
    reset(defaultValues => ({
      ...defaultValues,
      [AppointmentsReservePayload.flow]: FLOW_MODES.search,
    }));
  };
  return (
    <button
      type="button"
      className={cn(
        'text-teal-600 underline underline-offset-2 font-medium text-sm leading-4 hover:text-teal-500',
        className
      )}
      onClick={handleClick}
    >
      {t('AppointmentsReserve.SearchPsychologistBanner.cta')}
    </button>
  );
};

export const SearchPsychologistBanner = (): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);

  return (
    <AnimatedContainer
      transition={{ duration: 0.25, ease: 'easeInOut' }}
      className="w-full bg-plum-100 am-lg:max-w-196 am-lg:pl-4 am-lg:pr-6 px-4.5 py-3 flex justify-between items-center am-lg:rounded-xl"
    >
      <div>
        <p className="text-sm text-denim-800 font-medium leading-4">
          {t('AppointmentsReserve.SearchPsychologistBanner.title')}
        </p>
        <p className="text-sm text-denim-800 font-medium leading-4">
          {t('AppointmentsReserve.SearchPsychologistBanner.subtitle')}
          <ButtonCTA className="am-lg:hidden ml-1" />
        </p>
      </div>
      <ButtonCTA className="hidden am-lg:block" />
    </AnimatedContainer>
  );
};
